var map = {
	"./Diagnosis.png": "J22B",
	"./Diagnosis.svg": "/DUl",
	"./Doctor Profile.jpg": "Sxfz",
	"./Doctor Profile.svg": "Qg4b",
	"./Exercise plan.svg": "Q2tH",
	"./Exercise_Plan.jpg": "REBU",
	"./General Advice.png": "mOCc",
	"./General Advice.svg": "mS2t",
	"./Hospital.svg": "gKJM",
	"./Investigation.png": "CzQR",
	"./Investigation.svg": "TLrE",
	"./Prescription.jpg": "/0q4",
	"./Prescription.svg": "HsfE",
	"./Surgeon.svg": "A8At",
	"./Surgery.svg": "0K+g",
	"./Surgery_Icon.jpg": "pS41",
	"./Symptoms.png": "eChZ",
	"./Symptoms.svg": "9UEa",
	"./Treatment Plan.svg": "ma1+",
	"./book-doc-01.jpg": "rKEh",
	"./book-doc-02.jpg": "6KdA",
	"./book-doc-03.jpg": "CMNc",
	"./book-doc-04.jpg": "+0k6",
	"./book-doc-05.jpg": "XSGY",
	"./doctor-01.jpg": "v0gv",
	"./doctor-02.jpg": "+C89",
	"./doctor-03.jpg": "13Ux",
	"./doctor-04.jpg": "EFGk",
	"./doctor-05.jpg": "wox+",
	"./doctor-06.jpg": "PJq/",
	"./doctor-07.jpg": "1swk",
	"./doctor-08.jpg": "cp4y",
	"./doctor-09.jpg": "C4Ea",
	"./doctor-10.jpg": "cyB0",
	"./doctor-11.jpg": "yUmo",
	"./doctor-12.jpg": "Dkdx",
	"./doctor-thumb-01.jpg": "E8U8",
	"./doctor-thumb-02.jpg": "iEkO",
	"./doctor-thumb-03.jpg": "0P2w",
	"./doctor-thumb-04.jpg": "01w2",
	"./doctor-thumb-05.jpg": "+fV4",
	"./doctor-thumb-06.jpg": "iGh0",
	"./doctor-thumb-07.jpg": "IuEn",
	"./doctor-thumb-08.jpg": "WM9Z",
	"./doctor-thumb-09.jpg": "N9Cd",
	"./doctor-thumb-10.jpg": "qwSq",
	"./doctor-thumb-11.jpg": "jTgX",
	"./doctor-thumb-12.jpg": "sl5Z",
	"./doctor.png": "g3Hb",
	"./doctorss.jpg": "bWDj",
	"./exercise.png": "KnEm",
	"./exercisee.jpg": "AAEK",
	"./female_doctor.jpg": "wcCq",
	"./gallary_photo.jpg": "k6o8",
	"./hospital_img.png": "9wVr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hfA3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doctors ^\.\/.*$
// module id = hfA3
// module chunks = 0